import React, {useContext, useEffect, useRef, useState} from "react";
import {
    Form,
    Button,
    Input,
    FormGroup,
    Label,
    FormFeedback,
    Alert,
    Collapse,
} from "reactstrap";
import Toggle from "react-bootstrap-toggle";
import "react-bootstrap-toggle/dist/bootstrap2-toggle.css";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import Constants from "../../inc/Constants";
import Swal from "sweetalert2";
import LangContext from "../../providers/LangContext";
import {nl,enGB,de} from "date-fns/locale";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPaperclip} from "@fortawesome/pro-solid-svg-icons/faPaperclip";
import {faSpinner} from "@fortawesome/pro-solid-svg-icons/faSpinner";
import TextareaAutosize from "react-textarea-autosize";
import NumericInput from "../../../global-components/NumericInput";
import FormGroupInput from "../../../global-components/FormGroupInput";
import FormGroupSelect from "../../../global-components/FormGroupSelect";
import FormGroupDatePicker from "../../../global-components/FormGroupDatePicker";

const initialBid = {
    modal: false,
    modalType: 'nl',
    language: 'nl',
    offer: null,
    voorbeh_bouwk_keuring: false,
    bouwk_keuring_period: null,
    bouwk_keuring_amount: null,
    voorbeh_financiering: false,
    finance_period: null,
    finance_amount: null,
    finance_intermediair: null,
    voorbeh_nhg: false,
    voorbeh_overige: false,
    uitleg_voorbeh_overige: null,
    privacy_terms: false,
    bidding_on_behalf_of: null,
    gender: null,
    first_name: null,
    last_name: null,
    first_name_partner: null,
    last_name_partner: null,
    streetname: null,
    streetnumber: null,
    zipcode: null,
    city: null,
    country: 'nl',
    phone: null,
    email: '',
    email_confirmation: null,
    house_to_sell: null,
    remarks: null,
    purchase_broker: null,
    recaptcha: null,
    succesResponse: "",
    succesModal: false,
    recapKey: 2,
    loading: false,
    acceptance_date: null,
    acceptance_date_preference: null,
    view_date: null,
    errors: {},
};

const getLocale = (language) => {
    if ( language === 'nl' ) {
        return nl;
    }
    if ( language === 'de' ) {
        return de;
    }

    return enGB;

}

const BiddingModalNL = ({
                            online_bidding,
                            terms,
                            theme,
                            closeModal,
                            customBiddingFormText,
                            siteID
                        }) => {

    let recaptchaInstance;
    const {lang} = useContext(LangContext);

    const fileInputRef = useRef();
    const [attachments, setAttachments] = useState([]);

    const [bid, setBid] = useState({
        ...initialBid,
        language: lang.getLocale()
    });

    const countryOptions = [
        {label: lang.get('sites.netherlands', [], bid.language), value: 'nl'},
        {label: lang.get('sites.belgium', [], bid.language), value: 'be'},
        {label: lang.get('sites.germany', [], bid.language), value: 'de'},
    ];

    const onBehalfOfOptions = [
        {label: lang.get('sites.myself_and_possible_partner', [], bid.language), value: 'myself_and_possible_partner'},
        {label: lang.get('sites.my_customers_as_purchase_broker', [], bid.language), value: 'my_customers_as_purchase_broker'}
    ];

    useEffect(() => {
        recaptchaInstance.reset();
    }, [bid.loading]);

    useEffect(() => {
        setBid({
            ...bid,
            errors: {},
        });
    }, [bid.language]);

    // Check if it is a Hotmail/Live/Outlook e-mailaccount
    const [checkEmailAddress, setCheckEmailAddress] = useState(false);

    useEffect(() => {
        // Define an array of allowed domains
        const allowedDomains = ['@live', '@msn', '@hotmail', '@outlook'];

        // Check if the email contains any of the allowed domains
        const containsAllowedDomain = allowedDomains.some(domain => bid.email.includes(domain));

        // Update the checkEmailAddress state based on the result
        setCheckEmailAddress(containsAllowedDomain);
    }, [bid.email]);

    const inputChange = (e) => {
        setBid({
            ...bid,
            [e.target.name]: e.target.value
        })
    }

    const acceptDateChange = (e) => {
        if ( e.target.value !== 'specific_date' ) {
            setBid({
                ...bid,
                acceptance_date: null,
                [e.target.name]: e.target.value
            })
            return;
        }

        setBid({
            ...bid,
            [e.target.name]: e.target.value
        })
    }

    const checkboxChange = (e) => {
        setBid({
            ...bid,
            [e.target.name]: e.target.checked
        });
    }

    const changeByName = (name, value) => {
        setBid({
            ...bid,
            [name]: value
        });
    }

    const setRecaptchaKey = (value) => {
        setBid({
            ...bid,
            recaptcha: value
        })
    }

    const submitBiddingForm = (event) => {
        event.preventDefault();

        setBid({
            ...bid,
            loading: true
        });
        const formData =  new FormData();
        formData.append("bidData", JSON.stringify(bid));

        for (let i = 0; i < attachments.length; i++) {
            formData.append("attachments[]", attachments[i]);
        }

        axios.post("/api/site/" + siteID + "/biddingform",formData,
            {
                headers: {'Content-Type': 'multipart/form-data'}
            })
            .then(function (response) {
                Swal.fire({
                    title: lang.get("sites.online_bidding_thank_you", [], bid?.language),
                    text: response.data.success,
                    icon: "success",
                    timer: 3000
                });
                closeModal();
                setAttachments([]);
            }).catch(function (error) {
                console.log({error})
            if(error.response.data.errors) {
                setBid({
                    ...bid,
                    loading: false,
                    errors: error.response.data.errors
                })
            }
        });
    }

    const handleAddAttachments = (e) => {
        setAttachments([...attachments, ...Array.from(e.target.files)]);
        fileInputRef.current.value = null;
    }

    const removeAttachment = (index) => {
        setAttachments(attachments.filter((attachment, attIndex) => attIndex !== index));
    }

    const {errors} = bid;

    if (online_bidding == "0") {
        return null;
    }

    return (
        <>
            <style>
                {`
                .bidding-modal {
                    font-size: 13px;
                }

                .btn-success {
                    background-color: #28a745;
                    border-color: #28a745;
                }

                .btn-success:hover {
                    color: #fff;
                    background-color: #218838;
                    border-color: #28a745;
                }

                .btn-danger {
                    background-color: #dc3545;
                    border-color: #dc3545;
                }

                .btn-danger:hover {
                    color: #fff;
                    background-color: #c82333;
                    border-color: #bd2130;
                }
                `}
            </style>
            <div className="bidding-modal">

                <Form onSubmit={submitBiddingForm}>

                    <div className="px-lg-5 pt-lg-3">
                        <div className="row justify-content-between mb-3">
                            <div className="col">
                                {!!customBiddingFormText &&
                                    <div className="mb-4" dangerouslySetInnerHTML={{__html: customBiddingFormText}}></div>
                                }
                                <h3 className="font-weight-bold">{lang.get("sites.your_bid", [], bid.language)}</h3>
                                <div style={{maxWidth: '300px'}}>
                                    <NumericInput
                                        name={'offer'}
                                        onValueChange={(value) => {
                                            changeByName('offer', value.value)
                                        }}
                                        className="form-control form-control-lg"
                                        noLabel
                                        placeholder={lang.get('sites.your_bid', [], bid.language)}
                                        value={bid.offer}
                                        prepend="€"
                                        error={errors?.offer}
                                        autoComplete="off"
                                    />
                                </div>
                            </div>
                            <div className="col-lg-auto order-first order-lg-last">
                                <div className="text-center text-lg-left mb-3">
                                    {bid.language !== 'nl' &&
                                        <div className="mb-3 ml-2 ml-lg-0 cursor-pointer d-inline d-lg-block" onClick={() => {
                                            changeByName('language', 'nl')
                                        }}><img src="/images/nl.png" height="20px" alt="Nederlands" className="mr-2" />Nederlands</div>
                                    }
                                    {bid.language !== 'en' &&
                                        <div className="mb-3 ml-2 ml-lg-0 cursor-pointer d-inline d-lg-block" onClick={() => {
                                            changeByName('language', 'en')
                                        }}><img src="/images/en.png" height="20px" alt="English" className="mr-2" />English</div>
                                    }
                                    {bid.language !== 'de' &&
                                        <div className="mb-3 ml-2 ml-lg-0 cursor-pointer d-inline d-lg-block" onClick={() => {
                                            changeByName('language', 'de')
                                        }}><img src="/images/de.png" height="20px" alt="Deutsch" className="mr-2" />Deutsch</div>
                                    }
                                </div>
                            </div>
                        </div>

                        <h5>{lang.get("sites.reserved", [], bid.language)} ({lang.get('portal.optional', [], bid.language)})</h5>
                        <p className="text-muted">{lang.get('sites.reservations_explanation', [], bid.language)}</p>

                        <div className="row align-items-center">
                            <div className="col-auto pr-1">
                                <Toggle
                                    id="voorbeh_financiering"
                                    onClick={() => {
                                        changeByName('voorbeh_financiering', !bid.voorbeh_financiering)
                                    }}
                                    on={<div className="d-flex justify-content-center">{lang.get('sites.bids_toggle_yes', [], bid.language).toUpperCase()}</div>}
                                    off={<div className="text-center">{lang.get('sites.bids_toggle_no', [], bid.language).toUpperCase()}</div>}
                                    onstyle="success"
                                    offstyle="danger"
                                    active={!!bid.voorbeh_financiering}
                                />
                            </div>
                            <div className="col cursor-pointer" onClick={() => {
                                changeByName('voorbeh_financiering', !bid.voorbeh_financiering)
                            }}>
                                {lang.get("sites.reserved_financing", [], bid.language)}
                            </div>
                        </div>

                        <Collapse isOpen={!!bid.voorbeh_financiering}>
                            <div className="mt-3">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <NumericInput
                                            name={'finance_period'}
                                            onValueChange={(value) => {
                                                changeByName('finance_period', value.value)
                                            }}
                                            label={lang.get('sites.amount_weeks', [], bid.language)}
                                            placeholder={lang.get('sites.amount_weeks', [], bid.language)}
                                            value={bid.finance_period}
                                            append={lang.get('sites.weeks', [], bid.language).toLowerCase()}
                                            error={errors?.finance_period}
                                        />
                                        <NumericInput
                                            name={'finance_amount'}
                                            onValueChange={(value) => {
                                                changeByName('finance_amount', value.value)
                                            }}
                                            label={lang.get('sites.amount_to_financed', [], bid.language)}
                                            placeholder={lang.get('sites.amount_to_financed', [], bid.language)}
                                            value={bid.finance_amount}
                                            prepend="€"
                                            error={errors?.finance_amount}
                                        />
                                    </div>
                                </div>

                                <Label check className="mb-1">{lang.get("sites.name_financial_intermediary", [], bid.language)}:</Label>
                                <TextareaAutosize
                                    minRows={2}
                                    placeholder={lang.get("sites.name_financial_intermediary", [], bid.language)}
                                    className="form-control"
                                    name="finance_intermediair"
                                    value={bid.finance_intermediair || ''}
                                    onChange={inputChange}
                                />
                                <FormFeedback className="d-block">
                                    {errors?.finance_intermediair}
                                </FormFeedback>
                            </div>
                            <hr/>
                        </Collapse>

                        <div className="row align-items-center mt-3">
                            <div className="col-auto pr-1">
                                <Toggle
                                    id="voorbeh_bouwk_keuring"
                                    onClick={() => {
                                        changeByName('voorbeh_bouwk_keuring', !bid.voorbeh_bouwk_keuring)
                                    }}
                                    on={<div className="d-flex justify-content-center">{lang.get('sites.bids_toggle_yes', [], bid.language).toUpperCase()}</div>}
                                    off={<div className="text-center">{lang.get('sites.bids_toggle_no', [], bid.language).toUpperCase()}</div>}
                                    onstyle="success"
                                    offstyle="danger"
                                    active={!!bid.voorbeh_bouwk_keuring}
                                />
                            </div>
                            <div className="col cursor-pointer" onClick={() => {
                                changeByName('voorbeh_bouwk_keuring', !bid.voorbeh_bouwk_keuring)
                            }}>
                                {lang.get("sites.reservation_architectural", [], bid.language)}
                            </div>
                        </div>

                        <Collapse isOpen={!!bid.voorbeh_bouwk_keuring}>
                            <Label check>{lang.get('sites.when_to_carry_out_architectural_inspection', [], bid.language)}</Label>
                            <FormGroup check className="my-2">
                                <Label check className="mr-2">
                                    <Input
                                        type="radio"
                                        id="within_reflection_period"
                                        name="bouwk_keuring_period"
                                        value={"within_reflection_period"}
                                        checked={bid.bouwk_keuring_period === "within_reflection_period"}
                                        onChange={inputChange}
                                    />{" "}
                                    {lang.get("sites.within_reflection_period", [], bid.language)}
                                </Label>
                            </FormGroup>
                            <FormGroup check className="my-2">
                                <Label check>
                                    <Input
                                        type="radio"
                                        id="after_reflection_period"
                                        name="bouwk_keuring_period"
                                        value={"after_reflection_period"}
                                        checked={bid.bouwk_keuring_period === "after_reflection_period"}
                                        onChange={inputChange}
                                    />{" "}
                                    {lang.get("sites.after_reflection_period", [], bid.language)}
                                </Label>
                            </FormGroup>
                            <FormFeedback className="d-block">
                                {errors?.bouwk_keuring_period}
                            </FormFeedback>
                            <div className="row">
                                <div className="col-lg-7">
                                    <Collapse isOpen={bid.bouwk_keuring_period === 'after_reflection_period'}>
                                        <NumericInput
                                            name={'bouwk_keuring_amount'}
                                            onValueChange={(value) => {
                                                changeByName('bouwk_keuring_amount', value.value)
                                            }}
                                            label={lang.get("sites.bouwk_keuring_amount_label", [], bid.language)}
                                            placeholder={lang.get('sites.bouwk_keuring_amount', [], bid.language)}
                                            value={bid.bouwk_keuring_amount}
                                            prepend="€"
                                            error={errors?.bouwk_keuring_amount}
                                        />
                                    </Collapse>
                                </div>
                            </div>
                            <hr/>
                        </Collapse>

                        <div className="row align-items-center mt-3">
                            <div className="col-auto pr-1">
                                <Toggle
                                    id="voorbeh_nhg"
                                    onClick={() => {
                                        changeByName('voorbeh_nhg', !bid.voorbeh_nhg)
                                    }}
                                    on={<div className="d-flex justify-content-center">{lang.get('sites.bids_toggle_yes', [], bid.language).toUpperCase()}</div>}
                                    off={<div className="text-center">{lang.get('sites.bids_toggle_no', [], bid.language).toUpperCase()}</div>}
                                    onstyle="success"
                                    offstyle="danger"
                                    active={!!bid.voorbeh_nhg}
                                />
                            </div>
                            <div className="col cursor-pointer" onClick={() => {
                                changeByName('voorbeh_nhg', !bid.voorbeh_nhg)
                            }}>
                                {lang.get("sites.reservation_mortgage", [], bid.language)}
                            </div>
                        </div>

                        {!!bid.voorbeh_overige &&
                            <hr/>
                        }

                        <div className="row align-items-center mt-3">
                            <div className="col-auto pr-1">
                                <Toggle
                                    id="voorbeh_overige"
                                    onClick={() => {
                                        changeByName('voorbeh_overige', !bid.voorbeh_overige)
                                    }}
                                    on={<div className="d-flex justify-content-center">{lang.get('sites.bids_toggle_yes', [], bid.language).toUpperCase()}</div>}
                                    off={<div className="text-center">{lang.get('sites.bids_toggle_no', [], bid.language).toUpperCase()}</div>}
                                    onstyle="success"
                                    offstyle="danger"
                                    active={!!bid.voorbeh_overige}
                                />
                            </div>
                            <div className="col cursor-pointer" onClick={() => {
                                changeByName('voorbeh_overige', !bid.voorbeh_overige)
                            }}>
                                {lang.get("sites.other_reservations", [], bid.language)}
                            </div>
                        </div>

                        <Collapse isOpen={!!bid.voorbeh_overige}>
                            <div className="mt-2">
                                <Label check>
                                    {lang.get("sites.explanation_reservations", [], bid.language)}:
                                </Label>
                                <TextareaAutosize
                                    minRows={2}
                                    placeholder={lang.get("sites.explanation_reservations", [], bid.language)}
                                    className="form-control"
                                    name="uitleg_voorbeh_overige"
                                    value={bid.uitleg_voorbeh_overige || ''}
                                    onChange={inputChange}
                                />
                                <FormFeedback className="d-block">
                                    {errors?.uitleg_voorbeh_overige}
                                </FormFeedback>
                            </div>
                        </Collapse>

                        <hr />

                        <h3>{lang.get("sites.transfer_date", [], bid.language)}</h3>

                        <div className="row">
                            <div className="col-lg">
                                <FormGroup check className="my-2">
                                    <Label check className="mr-2">
                                        <Input
                                            type="radio"
                                            id="as_soon_as_possible"
                                            name="acceptance_date_preference"
                                            value={"as_soon_as_possible"}
                                            checked={bid.acceptance_date_preference === "as_soon_as_possible"}
                                            onChange={acceptDateChange}
                                            error={errors?.acceptance_date_preference}
                                        />{" "}
                                        {lang.get("sites.as_soon_as_possible", [], bid.language)}
                                    </Label>
                                </FormGroup>
                                <FormGroup check className="my-2">
                                    <Label check className="mr-2">
                                        <Input
                                            type="radio"
                                            id="in_consultation"
                                            name="acceptance_date_preference"
                                            value={"in_consultation"}
                                            checked={bid.acceptance_date_preference === "in_consultation"}
                                            onChange={acceptDateChange}
                                        />{" "}
                                        {lang.get("sites.in_consultation", [], bid.language)}
                                    </Label>
                                </FormGroup>
                                <FormGroup check className="my-2">
                                    <Label check className="mr-2">
                                        <Input
                                            type="radio"
                                            id="specific_date"
                                            name="acceptance_date_preference"
                                            value={"specific_date"}
                                            checked={bid.acceptance_date_preference === "specific_date"}
                                            onChange={acceptDateChange}
                                        />{" "}
                                        {lang.get("sites.specific_date", [], bid.language)}
                                    </Label>
                                </FormGroup>
                                <Collapse isOpen={bid.acceptance_date_preference === "specific_date"}>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <FormGroupDatePicker
                                                name={'acceptance_date'}
                                                locale={getLocale(bid.language)}
                                                noLabel
                                                placeholder={lang.get("sites.transfer_date", [], bid.language)}
                                                error={errors?.acceptance_date}
                                                onChange={(value) => changeByName('acceptance_date', value)}
                                                selected={bid.acceptance_date}
                                                minDate={new Date()}
                                                dateFormat="dd-MM-yyyy"
                                                autoComplete="off"
                                            />
                                        </div>
                                    </div>
                                </Collapse>

                                <FormFeedback className="d-block">
                                    {errors?.acceptance_date_preference}
                                </FormFeedback>

                            </div>
                        </div>

                        <hr/>

                        <h3>{lang.get("sites.your_information", [], bid.language)}</h3>

                        <div className="row">
                            <div className="col-lg-7">
                                <FormGroupSelect
                                    label={lang.get('sites.i_am_bidding_on_behalf_of', [], bid.language)+':'}
                                    name="bidding_on_behalf_of"
                                    value={onBehalfOfOptions.find(onbehalf => onbehalf.value === bid.bidding_on_behalf_of)}
                                    onChange={(onbehalf) => {
                                        changeByName('bidding_on_behalf_of', onbehalf.value)
                                    }}
                                    options={onBehalfOfOptions}
                                    placeholder={lang.get('sites.select_an_option', [], bid.language)}
                                    error={errors?.bidding_on_behalf_of}
                                />
                            </div>
                        </div>

                        <Collapse isOpen={bid.bidding_on_behalf_of === 'myself_and_possible_partner'}>
                            <>
                                <div className="row">
                                    <div className="col-lg-5">
                                        <FormGroupInput
                                            name={'first_name'}
                                            placeholder={lang.get("sites.first_name", [], bid.language)}
                                            value={bid.first_name || ''}
                                            label={lang.get("sites.first_name", [], bid.language)}
                                            onChange={inputChange}
                                            error={!!errors?.first_name ? errors?.first_name : ''}
                                        />
                                    </div>
                                    <div className="col-lg-5">
                                        <FormGroupInput
                                            name={'last_name'}
                                            placeholder={lang.get("sites.last_name", [], bid.language)}
                                            value={bid.last_name || ''}
                                            label={lang.get("sites.last_name", [], bid.language)}
                                            error={!!errors?.last_name ? errors?.last_name[0] : ''}
                                            onChange={inputChange}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-5">
                                        <FormGroupInput
                                            name={'first_name_partner'}
                                            placeholder={lang.get("sites.first_name", [], bid.language)}
                                            value={bid.first_name_partner || ''}
                                            label={lang.get("sites.first_name_partner", [], bid.language) + ' (' + lang.get("portal.optional", [], bid.language) + ')'}
                                            error={!!errors?.first_name_partner ? errors?.first_name_partner[0] : ''}
                                            onChange={inputChange}
                                        />
                                    </div>
                                    <div className="col-lg-5">
                                        <FormGroupInput
                                            name={'last_name_partner'}
                                            placeholder={lang.get("sites.last_name", [], bid.language)}
                                            value={bid.last_name_partner || ''}
                                            label={lang.get("sites.last_name_partner", [], bid.language) + ' (' + lang.get("portal.optional", [], bid.language) + ')'}
                                            error={!!errors?.last_name_partner ? errors?.last_name_partner[0] : ''}
                                            onChange={inputChange}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-5">
                                        <FormGroupInput
                                            name={'streetname'}
                                            placeholder={lang.get("sites.streetname", [], bid.language)}
                                            value={bid.streetname || ''}
                                            label={lang.get("sites.streetname", [], bid.language)}
                                            error={!!errors?.streetname ? errors?.streetname[0] : ''}
                                            onChange={inputChange}
                                        />
                                    </div>
                                    <div className="col-lg-4">
                                        <FormGroupInput
                                            name={'streetnumber'}
                                            placeholder={lang.get("sites.house_number", [], bid.language)}
                                            value={bid.streetnumber || ''}
                                            label={lang.get("sites.house_number", [], bid.language)}
                                            error={!!errors?.streetnumber ? errors?.streetnumber[0] : ''}
                                            onChange={inputChange}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-4">
                                        <FormGroupInput
                                            name={'zipcode'}
                                            placeholder={lang.get("sites.zipcode", [], bid.language)}
                                            value={bid.zipcode || ''}
                                            label={lang.get("sites.zipcode", [], bid.language)}
                                            error={!!errors?.zipcode ? errors?.zipcode[0] : ''}
                                            onChange={inputChange}
                                        />
                                    </div>
                                    <div className="col-lg-5">
                                        <FormGroupInput
                                            name={'city'}
                                            placeholder={lang.get("sites.city", [], bid.language)}
                                            value={bid.city || ''}
                                            label={lang.get("sites.city", [], bid.language)}
                                            error={!!errors?.city ? errors?.city[0] : ''}
                                            onChange={inputChange}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-7">
                                        <FormGroupSelect
                                            label={lang.get('sites.country', [], bid.language)+':'}
                                            name="country"
                                            value={countryOptions.find(country => country.value === bid.country)}
                                            onChange={(country) => {
                                                changeByName('country', country.value)
                                            }}
                                            options={countryOptions}
                                            placeholder={lang.get('sites.select_an_option', [], bid.language)}
                                            error={!!errors?.country ? errors?.country[0] : ''}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-7">
                                        <FormGroupInput
                                            name={'phone'}
                                            type={'tel'}
                                            placeholder={lang.get("sites.phone", [], bid.language)}
                                            value={bid.phone || ''}
                                            label={lang.get("sites.phone", [], bid.language)}
                                            error={!!errors?.phone ? errors?.phone[0] : ""}
                                            onChange={inputChange}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-7">
                                        <FormGroupInput
                                            name={'email'}
                                            type={'email'}
                                            placeholder={lang.get("sites.email", [], bid.language)}
                                            value={bid.email || ''}
                                            label={lang.get("sites.email", [], bid.language)}
                                            error={!!errors?.email ? errors?.email[0] : ''}
                                            onChange={inputChange}
                                        />
                                    </div>
                                </div>

                                <Collapse isOpen={checkEmailAddress}>
                                    <div className="alert alert-info mt-3" role="alert">
                                        <i className="fas fa-info-circle mr-1"></i>
                                        {
                                            {
                                                'nl': 'Let op: het is mogelijk dat uw bevestigingsmail niet aankomt bij Hotmail, Live, Outlook en MSN e-mailadressen. Uw bod wordt echter gewoon geplaatst.',
                                                'en': 'Please note: your confirmation email may not reach Hotmail, Live, Outlook and MSN email addresses. However, your bid will still be placed.',
                                                'de': 'Bitte beachten Sie: Ihre Bestätigungs-E-Mail erreicht möglicherweise keine Hotmail-, Live-, Outlook- und MSN-E-Mail-Adressen. Ihr Gebot wird jedoch weiterhin abgegeben.'
                                            }[bid.language]
                                        }
                                    </div>
                                </Collapse>

                                <div className="row">
                                    <div className="col-lg-7">
                                        <FormGroupInput
                                            name={'email_confirmation'}
                                            type={'email'}
                                            placeholder={lang.get("sites.email_again", [], bid.language)}
                                            value={bid.email_confirmation || ''}
                                            label={lang.get("sites.email_again", [], bid.language)}
                                            error={!!errors?.email_confirmation ? errors?.email_confirmation[0] : ''}
                                            onChange={inputChange}
                                        />
                                    </div>
                                </div>

                                <hr/>

                                <div className="row mb-2">
                                    <div className="col-lg-9">
                                        <Label check className="mb-1">
                                            {lang.get("sites.purchase_broker_info_if_applicable", [], bid.language)}:
                                        </Label>
                                        <TextareaAutosize
                                            minRows={2}
                                            placeholder={lang.get("sites.purchase_broker_info_if_applicable", [], bid.language)}
                                            className="form-control"
                                            id="purchase_broker_private"
                                            name="purchase_broker"
                                            value={bid.purchase_broker || ""}
                                            onChange={inputChange}
                                        />
                                        {!!errors?.purchase_broker ? <FormFeedback className="d-block">
                                            {errors?.purchase_broker[0]}
                                        </FormFeedback> : ''}
                                    </div>
                                </div>

                                <div className="d-flex justify-content-start align-middle mb-2">
                                    <div className="mt-1 mr-2 me-2">
                                        <Label check>{lang.get("sites.house_to_sell_question", [], bid.language)}</Label>
                                    </div>
                                    <div className="col-lg-3 align-self-center">
                                        <FormGroup check inline={true} className="my-2">
                                            <Label check className="mr-3">
                                                <Input
                                                    type="radio"
                                                    id="house_to_sell_yes"
                                                    name="house_to_sell"
                                                    value="1"
                                                    checked={bid.house_to_sell === "1"}
                                                    onChange={inputChange}
                                                />{" "}
                                                {lang.get("sites.yes", [], bid.language)}
                                            </Label>
                                        </FormGroup>
                                        <FormGroup check inline={true} className="my-2">
                                            <Label check>
                                                <Input
                                                    type="radio"
                                                    id="house_to_sell_no"
                                                    name="house_to_sell"
                                                    value="0"
                                                    checked={bid.house_to_sell === "0"}
                                                    onChange={inputChange}
                                                />{" "}
                                                {lang.get("sites.no", [], bid.language)}
                                            </Label>
                                        </FormGroup>
                                        {!!errors?.house_to_sell ? <FormFeedback className="d-block">
                                            {errors?.house_to_sell[0]}
                                        </FormFeedback> : '' }
                                    </div>
                                </div>
                            </>
                        </Collapse>

                        <Collapse isOpen={bid.bidding_on_behalf_of === "my_customers_as_purchase_broker"}>
                            <>
                                <div className="row">
                                    <div className="col-lg-8">
                                        <FormGroupInput
                                            name={'purchase_broker'}
                                            placeholder={lang.get("sites.brokerage_firm_name", [], bid.language)}
                                            value={bid.purchase_broker || ''}
                                            label={lang.get("sites.brokerage_firm_name", [], bid.language)}
                                            error={!!errors?.purchase_broker ? errors?.purchase_broker[0] : ''}
                                            onChange={inputChange}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-4">
                                        <FormGroupInput
                                            name={'first_name'}
                                            placeholder={lang.get("sites.first_name", [], bid.language)}
                                            value={bid.first_name || ''}
                                            label={lang.get("sites.first_name", [], bid.language)}
                                            error={!!errors?.first_name ? errors?.first_name[0] : ''}
                                            onChange={inputChange}
                                        />
                                    </div>
                                    <div className="col-lg-4">
                                        <FormGroupInput
                                            name={'last_name'}
                                            placeholder={lang.get("sites.last_name", [], bid.language)}
                                            value={bid.last_name || ''}
                                            label={lang.get("sites.last_name", [], bid.language)}
                                            error={!!errors?.last_name ? errors?.last_name[0] : ''}
                                            onChange={inputChange}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-lg-8">
                                        <FormGroupInput
                                            name={'phone'}
                                            type={'tel'}
                                            placeholder={lang.get("sites.phone", [], bid.language)}
                                            value={bid.phone || ''}
                                            label={lang.get("sites.phone", [], bid.language)}
                                            error={!!errors?.phone ? errors?.phone[0] : ''}
                                            onChange={inputChange}
                                        />
                                    </div>
                                </div>

                                <div className="row mb-2">
                                    <div className="col-lg-8">
                                        <FormGroupInput
                                            name={'email'}
                                            type={'email'}
                                            placeholder={lang.get("sites.email", [], bid.language)}
                                            value={bid.email || ''}
                                            label={lang.get("sites.email", [], bid.language)}
                                            error={!!errors?.email ? errors?.email[0] : ''}
                                            onChange={inputChange}
                                        />
                                        <FormGroupInput
                                            name={'email_confirmation'}
                                            type={'email'}
                                            placeholder={lang.get("sites.email_again", [], bid.language)}
                                            value={bid.email_confirmation || ''}
                                            label={lang.get("sites.email_again", [], bid.language)}
                                            error={!!errors?.email_confirmation ? errors?.email_confirmation[0] : ''}
                                            onChange={inputChange}
                                        />
                                    </div>
                                </div>
                            </>
                        </Collapse>

                        <hr />

                        <div className="row">
                            <div className="col col-lg-6">
                                <FormGroupDatePicker
                                    name={'view_date'}
                                    locale={getLocale(bid.language)}
                                    label={lang.get("sites.date_viewing", [], bid.language)}
                                    placeholder={lang.get("sites.view_date_placeholder", [], bid.language)}
                                    error={!!errors?.view_date ? errors?.view_date[0] : ''}
                                    onChange={(value) => changeByName('view_date', (!value ? null : value))}
                                    isClearable
                                    selected={!!bid.view_date ? bid.view_date : null}
                                    dateFormat="dd-MM-yyyy"
                                    autoComplete="off"
                                    disabledKeyboardNavigation={true}
                                />
                            </div>
                        </div>
                        <hr/>

                        <div className="row mb-2">
                            <div className="col-lg-9">
                                <Label check>{lang.get("sites.remarks", [], bid.language)} ({lang.get('portal.optional', [], bid.language)})</Label>
                                <TextareaAutosize
                                    minRows={2}
                                    placeholder={lang.get("sites.remarks_optional", [], bid.language)}
                                    invalid={!!errors?.remarks || 'false'}
                                    className="form-control"
                                    name="remarks"
                                    onChange={inputChange}
                                />
                                {errors?.remarks ? <FormFeedback className="d-block">
                                    {errors.remarks[0]}
                                </FormFeedback> : ''}
                            </div>
                        </div>

                        <div className="row mb-2">
                            <div className="col-lg-9">
                                <input
                                    ref={fileInputRef}
                                    onChange={handleAddAttachments}
                                    hidden
                                    accept="image/png,image/jpeg,image/jpg,.pdf"
                                    multiple type={'file'}/>
                                <button className={'btn btn-outline-secondary btn-sm mb-2'} onClick={(e)=> {
                                    e.preventDefault()
                                    fileInputRef.current.click();
                                }}>
                                    <FontAwesomeIcon icon={faPaperclip} />
                                    {' '} {lang.get("sites.add_attachment_s", [], bid.language)}
                                </button>
                            </div>
                        </div>
                        {attachments.length > 0 &&
                            <div className="mt-2">
                                {lang.get('sites.attachments', [], bid.language)}:
                                <ul>
                                    {attachments.map((file, index) => {
                                        return <li key={file.name}>{file.name} <span className="cursor-pointer text-primary" onClick={() => removeAttachment(index)}><u>{lang.get('portal.delete').toLowerCase()}</u></span><br/><span className={'text-danger'}>{errors?.['attachments.'+index]?.[0]}</span></li>
                                    })}
                                </ul>
                            </div>
                        }

                        <FormGroup className="mr-1 mt-3" check>
                            <Label check>
                                <Input
                                    invalid={!!errors?.privacy_terms}
                                    type="checkbox"
                                    name="privacy_terms"
                                    value={bid.privacy_terms || ''}
                                    checked={bid.privacy_terms}
                                    onChange={checkboxChange}
                                />{" "}
                                {lang.get("sites.bieding_terms_before", [], bid.language)}{" "}
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: lang.get("sites.bieding_terms_url", {termsLink: terms}, bid.language)
                                    }}
                                />{'. '}
                                {lang.get("sites.bieding_terms_after", [], bid.language)}
                                <FormFeedback className="d-block">
                                    {errors?.privacy_terms}
                                </FormFeedback>
                            </Label>
                        </FormGroup>

                        <div className="mb-2">
                            <ReCAPTCHA
                                sitekey={Constants.RECAPTHCA_KEY.siteKey}
                                onChange={setRecaptchaKey}
                                hl={bid.language}
                                ref={e => recaptchaInstance = e}
                                // key={bid.recapKey}
                                theme={theme === "v1" ? "dark" : "light"}
                            />
                            <FormFeedback className="d-block">
                                {errors?.recaptcha}
                            </FormFeedback>
                        </div>

                        {Object.keys(errors)?.length > 0 && (
                            <Alert color="danger">
                                {lang.get("sites.bidding_form_has_errors", [], bid.language)}
                            </Alert>
                        )}

                        <hr />

                        <Button className="btn btn-primary" type="submit">
                            {bid.loading && (
                                <FontAwesomeIcon icon={faSpinner} spin />
                            )}{" "}
                            {lang.get("sites.place_bid", [], bid.language)}{" "}
                        </Button>

                    </div>

                </Form>

            </div>

        </>
    );
}

export default BiddingModalNL;
